<script>
export default {
  name: "PageHeading",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <header
    :id="anchorId"
    class="page-heading bg-white border-bottom border-gray-100"
  >
    <div class="page-heading-inner mx-auto">
      <h1 class="page-heading-title text-gray-900 mb-1">{{ title }}</h1>
      <p
        v-if="description"
        class="page-heading-description text-gray-500 mb-0"
      >{{ description }}</p>
      <div v-if="$slots.tabs" class="page-heading-tabs">
        <slot name="tabs" />
      </div>
    </div>
  </header>
</template>

<style scoped>
.page-heading {
  padding: 1.5rem;
}

/* Tabs sit flush on the header's bottom border so the active
   underline reads as connected to the content below. */
.page-heading-tabs {
  margin-top: 1rem;
  margin-bottom: -1.5rem;
}

.page-heading-inner {
  max-width: 1200px;
}

.page-heading-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
}

.page-heading-description {
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .page-heading {
    padding: 1rem 1rem 0.875rem;
  }

  .page-heading-title {
    font-size: 20px;
  }

  .page-heading-description {
    font-size: 13px;
  }

  .page-heading-tabs {
    margin-top: 0.75rem;
    margin-bottom: -0.875rem;
  }
}
</style>
